import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { API_URL } from '../../utils/constants';
import auth from '../../Auth';
import { Button, Table, TableBody, TableCell, TableColumn, TableHeader, TableRow } from '@nextui-org/react';
import Breadcrumbs from '../Breadcrumbs';
import { Loader2 } from 'lucide-react';

const InvitationsPage = () => {
  const { org_id } = useParams();
  const [invitations, setInvitations] = useState([]);
  const [fetched, setFetched] = useState(false);

  const fetchInvitations = async () => {
    await axios
      .get(`${API_URL}/invitations?fetch&org_id=${org_id}`, {
        headers: {
          Authorization: `Bearer ${await auth.getIdToken()}`
        }
      })
      .then((res) => {
        setInvitations(res.data);
        setFetched(true);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchInvitations();
  }, []);

  const crumbs = [
    { path: '/', breadcrumb: 'Home' },
    { path: '/settings', breadcrumb: 'Settings' },
    { path: '/settings/organizations', breadcrumb: 'Organizations' },
    { path: '/settings/organizations/invitations/:org_id', breadcrumb: 'Invitations' }
  ];

  return (
    <div className='flex flex-col w-full p-8 space-y-8'>
      {fetched ? (
        <>
          <Breadcrumbs crumbs={crumbs} />
          <div className='col-span-2 grid grid-cols-1 gap-4'>
            <h1 className='col-span-4 text-2xl font-bold'>Invitations:</h1>
          </div>
          <Table isHeaderSticky className='w-4/5' width={500} aria-label='Invitations'>
            <TableHeader width={500}>
              <TableColumn key='sender_email'>Sender</TableColumn>
              <TableColumn key='recipient_email'>Recepient</TableColumn>
              <TableColumn key='org_name'>Organization</TableColumn>
              <TableColumn key='date'>Date</TableColumn>
            </TableHeader>
            <TableBody items={invitations}>
              {(item) => (
                <TableRow key={item.org_id}>
                  <TableCell>{item.sender_email}</TableCell>
                  <TableCell>{item.recipient_email}</TableCell>
                  <TableCell>{item.org_name}</TableCell>
                  <TableCell>{item.datetime}</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </>
      ) : (
        <Loader2 size={50} className='animate-spin' />
      )}
    </div>
  );
};

export default InvitationsPage;
